import { useCallback, useRef, useState } from "react";
import PropTypes from "prop-types";
import { MenuList } from "app/components/form/ReactSelectField/componentsOverrides";
import { makeStableClassName } from "app/components/form/utils/stableClassName";
import { NAVIGATION_KEYS } from "app/constants";

const useOptionInteractionTracking = dataTestId => {
	const [hasInteracted, setHasInteracted] = useState(false);
	// Read via ref (not state) inside InteractiveMenuList so it stays memoized on dataTestId alone.
	const hasInteractedRef = useRef(hasInteracted);
	hasInteractedRef.current = hasInteracted;

	const InteractiveMenuList = useCallback(
		props => {
			const { innerProps = {} } = props;

			return (
				<MenuList
					{...props}
					stableClassName={makeStableClassName(dataTestId)(
						"react-select-field__menu-list"
					)}
					stableTestId={`${dataTestId}-menu-list`}
					innerProps={{
						...innerProps,
						"data-interacted": hasInteractedRef.current || undefined,
						onMouseMove: event => {
							innerProps.onMouseMove?.(event);
							setHasInteracted(true);
						},
					}}
				/>
			);
		},
		[dataTestId]
	);

	InteractiveMenuList.propTypes = {
		innerProps: PropTypes.object,
	};

	const handleMenuOpen = useCallback(() => setHasInteracted(false), []);

	const handleKeyDown = useCallback(event => {
		if (NAVIGATION_KEYS.includes(event.key)) {
			setHasInteracted(true);
		}
	}, []);

	return { InteractiveMenuList, handleMenuOpen, handleKeyDown };
};

export { useOptionInteractionTracking };
